/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForResourceTagRemediation extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForResourceTagRemediation");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForResourceTagRemediation.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForResourceTagRemediation>): BackgroundJobPayloadForResourceTagRemediation {
        let obj = Object.assign(new BackgroundJobPayloadForResourceTagRemediation(), model);
        BackgroundJobPayloadForResourceTagRemediation.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForResourceTagRemediation>): BackgroundJobPayloadForResourceTagRemediation {
        if (!model) return null;
        return BackgroundJobPayloadForResourceTagRemediation.newInstance(<BackgroundJobPayloadForResourceTagRemediation> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForResourceTagRemediation) {
        if (!obj) return;

        models.BackgroundJobPayloadForResourceTagRemediation.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForResourceTagRemediation): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForResourceTagRemediation.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
